export const WORLD_CONTENT_COL_WIDTH = '3xl:max-w-[1296px] lg:min-w-2xl' as const

export const WORLD_DETAIL_SECTION_GRID =
  '3xl:mx-auto 3xl:max-w-[1920px] 3xl:grid-cols-[minmax(0,1296px)_auto] 3xl:justify-center 3xl:px-[72px] 1.5xl:py-8 1.5xl:gap-6 1.5xl:px-[25px] lg:mx-auto lg:w-full lg:grid-cols-[minmax(0,1fr)_auto] lg:grid-rows-[auto_1fr] lg:gap-4 lg:px-5 lg:py-6' as const

/**
 * Width of the desktop recommendation rail: 360px (two 176px cards and an 8px gap) from `xl`, per
 * the Figma designs at 1440px and 1920px. Below `xl` it stays a single 280px column, because the
 * 672px player column leaves no room for 360px until 1088px.
 */
export const RECOMMEND_COLUMN_WIDTH = 'lg:w-[280px] xl:w-[360px]' as const

/** Grid for the recommendation cards: 3 columns on tablet, 1 below `xl`, 2 from `xl`. */
export const RECOMMEND_GRID_DESKTOP =
  'md:grid md:grid-cols-3 md:gap-2 md:gap-y-8 lg:grid-cols-1 lg:gap-4 xl:grid-cols-2 xl:gap-2' as const

export const MOBILE_PLAY_POSITION_FLAG_KEY = 'content-detail-mobile-play-position'

/**
 * `test` floats the CTA above the consent banner (CONNECT-6017); `icon-label` adds a play icon
 * beside the label and `icon-only` swaps the button for a centred icon on the media (CONNECT-6141).
 */
export const MOBILE_PLAY_POSITION_VARIANTS = ['control', 'test', 'icon-label', 'icon-only'] as const

export type MobilePlayPosition = (typeof MOBILE_PLAY_POSITION_VARIANTS)[number]

/**
 * Furthest the overlay stack may shift before its top crosses the media block and `overflow-hidden`
 * clips the world title: the 300px landscape block, less the 18px resting inset, less the stack's
 * 160px height (title 26 + creator 18 + CTA 48 + action row 36, plus its 8/8/16px gaps).
 *
 * Reached on a 932x430 landscape viewport, where the banner measures 138px and would otherwise
 * ask for a 146px shift. Clamping still clears the banner there by 136px.
 */
export const MEDIA_OVERLAY_STACK_MAX_SHIFT = 122
